<template>
  <button
    class="cursor-pointer border px-3 py-1-5"
    :class="{
      'rounded-l': leftEnd,
      'rounded-r': rightEnd,
    }"
  >
    <icon-base
      height="24"
      width="24"
      :icon="icon"
      :icon-color="active ? UTIL_COLORS.PRIMARY : UTIL_COLORS.DEFAULT"
    />
  </button>
</template>
<script setup lang="ts">
import { UTIL_COLORS } from "@/helpers/constants";

import type { Component, ComponentOptions, PropType } from "vue";

defineProps({
  active: {
    type: Boolean,
    default: false,
  },
  icon: {
    type: [String, Object] as PropType<
      string | (ComponentOptions | ComponentOptions["setup"]) | Component
    >,
    required: true,
  },
  leftEnd: {
    type: Boolean,
    default: false,
  },
  rightEnd: {
    type: Boolean,
    default: false,
  },
});
</script>
